<template>
  <div class="eemo-page-shell" style="background: white;">
  <div class="tnc-body">
    <h5>Booking privacy notice</h5>
    <p>Last updated 1 October 2026.</p>
    <p>
      This notice explains how a table reservation made through Show Me The Menu is handled.
      Show Me The Menu is a brand of <b>Borium Studio Limited</b>, Unit 68, Trident Court,
      1 Oakcroft Road, Chessington KT9 1BD, United Kingdom.
    </p>

    <h6>1. Who is responsible</h6>
    <p>
      The restaurant you book is responsible for your reservation and for the details it needs to host you.
      Borium Studio Limited provides the booking pages, the restaurant dashboard, confirmation and cancellation emails,
      and the connection to Google when you book with Reserve with Google.
    </p>

    <h6>2. What we hold</h6>
    <p>A booking can include:</p>
    <ul>
      <li>your name, phone number and email address</li>
      <li>the date, time and length of the reservation</li>
      <li>the number of adults, children and toddlers</li>
      <li>the booking type or seating choice, such as restaurant or buffet, and a table where the restaurant assigns one</li>
      <li>a note from you, and a message from the restaurant if they cancel or reply</li>
      <li>the status of the booking, such as confirmed, cancelled, arrived or no-show</li>
    </ul>
    <p>
      If you book on Google, Google sends us the reservation details, including a Google booking reference.
      We send Google the status when the restaurant or you cancel, or when the restaurant marks a no-show.
    </p>

    <h6>3. Why we use it</h6>
    <p>The restaurant and Show Me The Menu use these details to:</p>
    <ul>
      <li>make, confirm, change or cancel the reservation</li>
      <li>email you about the booking</li>
      <li>show the booking to the restaurant’s staff on the dashboard and the till</li>
      <li>keep a record of the visit, including a no-show</li>
    </ul>
    <p>
      The legal basis is the steps needed to provide the reservation you asked for, and the restaurant’s legitimate interest
      in running its booking book. We do not sell your details.
    </p>

    <h6>4. Who else receives it</h6>
    <p>
      The restaurant you booked can see the booking. Show Me The Menu staff can access it to run and support the service.
      Emails are sent through Mailjet. If the booking came from Google, status updates are sent to Google.
      We do not pass the booking to other restaurants.
    </p>

    <h6>5. How long it is kept</h6>
    <p>
      The booking record stays so the restaurant can manage that visit and deal with a later question about it.
      You can ask the restaurant to correct or delete your details. A record may be kept where it is needed for a dispute
      or where the law requires it.
    </p>

    <h6>6. Your rights</h6>
    <p>
      You can ask for a copy of your booking details, ask for a correction, or ask for deletion.
      Contact the restaurant first, because they hold the reservation.
      You can also complain to the Information Commissioner’s Office at ico.org.uk.
    </p>
  </div>
  </div>
</template>

<script>
export default {
  name: "BookingPrivacy"
}
</script>

<style scoped>
.tnc-body {
  text-align: left;
  padding: 10px 15px 20px 15px;
  font-size: 14px;
  color: #333;
  line-height: 1.45;
  max-width: 760px;
  margin: 0 auto;
}
.tnc-body h5 {
  font-weight: 700;
  margin-bottom: 12px;
}
.tnc-body h6 {
  font-weight: 700;
  margin-top: 18px;
  margin-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/BookingPrivacy.vue